"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUniqueLogoNames = getUniqueLogoNames;
exports.getLogoNamePropType = getLogoNamePropType;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createChainablePropType = _interopRequireDefault(require("./createChainablePropType"));

var logoNames;
var propType;

function getUniqueLogoNames() {
  if (!logoNames) {
    logoNames = process.env.NODE_ENV === 'production' ? [] : Object.keys(require('ui-images/metadata').logos);
  }

  return logoNames;
}

function getLogoNamePropType() {
  if (!propType) {
    propType = _propTypes.default.oneOf(getUniqueLogoNames());
  }

  return (0, _createChainablePropType.default)(propType, 'logoName');
}